import React, {useContext, useEffect, useState} from "react";
import dayjs, { Dayjs } from 'dayjs'
import { Select, Button, Radio, Space, App, Form, Typography } from "antd";
import { FaInfoCircle } from "react-icons/fa";
import { RiDeleteBin2Line } from "react-icons/ri";
import { DatePicker } from "antd-jalali";
import { Enum, API } from "../../resources/constants";
import language from "../../resources/languages/fa_IR";
import { ActionType } from  './../../resources/constants'

// Interfaces
import { AxiosError, AxiosResponsePaginate } from "../../interfaces/axios"
import { Location } from "../../interfaces/travel"

// Contexts
import GlobalContext from '../../contexts/global';
import AxiosContext from "../../contexts/axios";

const { Components: { Filter }, Validation, Share, Enum: EnumLanguage, Message: MessageLanguage } = language
const { Message, Capacity, TravelType, TravelMod } = Enum
const { SET_FILTER, SET_TRAVEL, SET_OPEN_DRAWER, SET_DESTINATION, SET_DESTINATION_LOCATION, SET_ORIGIN, SET_ORIGIN_LOCATION, SET_DIRECTIONS, SET_TRAVEL_MOD } = ActionType
const { TRAVEL_TRAVEL_PAGINATE, TRAVEL_TRAVEL_MY_PAGINATE } = API

interface ProvinceType {
    id: string,
    name: string,
    cities: CityType[],
}
interface CityType {
    id: string,
    name: string,
    locations: Location[],
}
export default function Index() {

    const [form] = Form.useForm()
    const [, forceUpdate] = useState({})
    const [capacity, setCapacity] = useState<boolean>(true)
    const { provinces, owners, cars, filter, dispatch } = useContext(GlobalContext)
    const { axios } = useContext(AxiosContext)
    const { message } = App.useApp()

    // To disable submit button at the beginning.
    useEffect(() => {
        forceUpdate({})
        // @ts-ignore
        const { travelType = TravelType.Person } = filter;
        form.setFieldsValue(filter)
        setCapacity(travelType === TravelType.Person)
    }, []);

    const onFinish = (filter: {}) => {
        dispatch({ type: SET_FILTER , payload: { filter }})
        getTravel(filter)
    };

    const getTravel = (filter: {}) => axios.post(TRAVEL_TRAVEL_PAGINATE, filter, { params: { page: 1, limit: 1 }}).then((response: AxiosResponsePaginate) => {
        const { data, data: { docs } } = response
        const travel =  docs.length ? { ...docs[0], paginate: { ...data, docs: null } } : {}
        dispatch({ type: SET_TRAVEL , payload: { travel }})
        dispatch({ type: SET_TRAVEL_MOD , payload: { travelMod: TravelMod.NEW }})
        dispatch({ type: SET_OPEN_DRAWER , payload: { openDrawer: false }})
        resetDirections()
    }).catch( (error: AxiosError) => {
        const { response: { data } } = error;
        dispatch({ type: SET_TRAVEL , payload: { travel: {} }})
        dispatch({ type: SET_TRAVEL_MOD , payload: { travelMod: TravelMod.NEW }})
        resetDirections()
        // @ts-ignore
        message.error(MessageLanguage[Message.ERROR_SEARCH]).then(response => response)
    });

    const resetDirections = () => {
        dispatch({ type: SET_DESTINATION , payload: { destination: null }})
        dispatch({ type: SET_DESTINATION_LOCATION , payload: { destinationLocation: null }})
        dispatch({ type: SET_ORIGIN , payload: { origin: null }})
        dispatch({ type: SET_ORIGIN_LOCATION , payload: { originLocation: null }})
        dispatch({ type: SET_DIRECTIONS , payload: { directions: { routes: [] } }})
    }

    const getCapacityToNumber = (capacity: string) => {
        switch (capacity) {
            case Capacity.ONE:
                return 1;
            case Capacity.TWO:
                return 2;
            case Capacity.THREE:
                return 3;
        }
    }

    return (
        <Form form={form} name="filter" onFinish={onFinish} >
            <Space.Compact block>
                <Form.Item
                    style={{width:'100%'}}
                    name="origin"
                    dependencies={['destination']}
                    rules={[
                        { required: true, message: `${Filter.origin} ${Validation.required}` },
                    ]}
                >
                    <Select
                        showSearch
                        placeholder={Filter.origin}
                        optionFilterProp="name"
                        options={provinces.map(({ name, cities }) => ({ label: name, options: cities.map(({ id, name }) => ({ label: name, value: id, name }))}))}
                    />
                </Form.Item>
                <Button style={{lineHeight:0}} type="primary" icon={<RiDeleteBin2Line size={22} />} onClick={() => form.resetFields(['origin'])}/>
            </Space.Compact>
            <Space.Compact block>
            <Form.Item
                style={{width:'100%'}}
                name="destination"
                dependencies={['origin']}
                rules={[
                    { required: true, message: `${Filter.destination} ${Validation.required}` },
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            if (!value || getFieldValue('origin') !== value) return Promise.resolve()
                            else return Promise.reject(new Error(Validation.equalOriginDestination))
                        },
                    }),
                ]}
            >
                <Select
                    showSearch
                    placeholder={Filter.destination}
                    optionFilterProp="name"
                    options={provinces.map(({ name, cities }) => ({ label: name, options: cities.map(({ id, name }) => ({ label: name, value: id, name }))}))}
                />
            </Form.Item>
            <Button style={{lineHeight:0}} type="primary" icon={<RiDeleteBin2Line size={22} />} onClick={() => form.resetFields(['destination'])}/>
            </Space.Compact>
            <Space.Compact block>
            <Form.Item
                style={{width:'100%',marginBottom:14}}
                name="date"
                extra={<Space><FaInfoCircle style={{marginTop:8}} /><Typography.Text style={{fontSize:12}}>{Share.optional}</Typography.Text></Space>}
            >
                <DatePicker allowClear={false}
                            placeholder={Filter.date}
                            style={{ width: '100%' }}
                            format="D MMMM"
                            disabledDate={(current: Dayjs) => current && current < dayjs().startOf('day')}
                />
            </Form.Item>
                <Button style={{lineHeight:0}} type="primary" icon={<RiDeleteBin2Line size={22} />} onClick={() => form.resetFields(['date'])}/>
            </Space.Compact>
            <Space.Compact block>
                <Form.Item
                    style={{width:'100%',marginBottom:14}}
                    name="owner"
                    extra={<Space><FaInfoCircle style={{marginTop:8}} /><Typography.Text style={{fontSize:12}}>{Share.optional}</Typography.Text></Space>}
                >
                    <Select
                        showSearch
                        placeholder={Filter.owner}
                        optionFilterProp="label"
                        options={owners.map(({ company, id }) => ({ label: company, value: id }))}
                    />
                </Form.Item>
                <Button style={{lineHeight:0}} type="primary" icon={<RiDeleteBin2Line size={22} />} onClick={() => form.resetFields(['owner'])}/>
            </Space.Compact>
            <Space.Compact block>
            <Form.Item
                style={{width:'100%',marginBottom:14}}
                name="car"
                extra={<Space><FaInfoCircle style={{marginTop:8}} /><Typography.Text style={{fontSize:12}}>{Share.optional}</Typography.Text></Space>}
            >
                <Select
                    showSearch
                    placeholder={Filter.car}
                    optionFilterProp="label"
                    options={cars.map(({ name, id }) => ({ label: name, value: id }))}
                />
            </Form.Item>
                <Button style={{lineHeight:0}} type="primary" icon={<RiDeleteBin2Line size={22} />} onClick={() => form.resetFields(['car'])}/>
            </Space.Compact>
            <Space.Compact block>
                <Form.Item
                    style={{width:'100%',marginBottom:14}}
                    name="capacity"
                    extra={<Space><FaInfoCircle style={{marginTop:8}} /><Typography.Text style={{fontSize:12}}>{Share.optional}</Typography.Text></Space>}
                >
                    <Select
                        disabled={!capacity}
                        placeholder={Filter.capacity}
                        optionFilterProp="children"
                        options={Object.values(Capacity).map((capacity) => ({ label: EnumLanguage.Capacity[capacity], value: getCapacityToNumber(capacity)}))}
                    />
                </Form.Item>
                <Button style={{lineHeight:0}} type="primary" icon={<RiDeleteBin2Line size={22} />} onClick={() => form.resetFields(['capacity'])}/>
            </Space.Compact>
            <Form.Item
                style={{marginBottom:14}}
                name="travelType"
                className={'filter-radio'}
                extra={<Space><FaInfoCircle style={{marginTop:8}} /><Typography.Text style={{fontSize:12}}>{Share.optional}</Typography.Text></Space>}
            >
                <Radio.Group
                    optionType="button"
                    size="large"
                    buttonStyle="solid"
                    onChange={({ target: { value: travelType }}) => {
                        setCapacity(travelType === TravelType.Person)
                        form.resetFields(['capacity']);
                    }}
                >
                    {Object.values(TravelType).map((travelType, index) => (<Radio.Button key={index} value={travelType} onClick={() => {
                        if (form.getFieldValue('travelType') === travelType) {
                            form.resetFields(['travelType'])
                            setCapacity(true)
                        }
                    }}>{EnumLanguage.TravelType[travelType]}</Radio.Button>))}
                </Radio.Group>
            </Form.Item>
            <Form.Item shouldUpdate>
                {() => (
                    <Space direction="vertical" style={{ width: '100%' }}>
                        <Button
                            type="primary"
                            block
                            htmlType="submit"
                            disabled={!!form.getFieldsError().filter(({ errors }) => errors.length).length}
                        >
                            { Filter.search }
                        </Button>
                    <Button
                        block
                        htmlType="reset"
                        onClick={() => {
                            setCapacity(true)
                            dispatch({ type: SET_FILTER , payload: { filter: {} }})
                            getTravel({})
                        }}
                    >
                        { Filter.reset }
                    </Button>
                    </Space>
                )}
            </Form.Item>
        </Form>
    )
}
